import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { GlobalAttribute } from "@medapro-types/common/common";
import { Branch, Leaf, MultiLevelNavigationConfirmModel } from "@medapro-types/common/components/MultiLevelNavigation";
import globalAttributesApi from "@services/globalAttributes.js";
import { computed } from "vue";
import MultiLevelNavigationModal from "./MultiLevelNavigationModal.vue";

const LEAF_ICON = "Attribute";

//#region General

export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalAttributeSelectionModal',
  props: {
    value: { type: Boolean },
    selectedEntryId: {}
  },
  emits: ["confirm", "input", "cancel", "close", "hide"],
  setup(__props: any, { emit: emits }) {

const props = __props;




//#endregion

//#region Store
const { primaryLanguageCode } = useContentLanguages();
//#endregion

const onConfirm = (event: MultiLevelNavigationConfirmModel) => {
  emits("confirm", event);
};

//#region localValue
const localValue = computed({
  get: () => props.value,
  set: (nv) => emits("input", nv)
});

//#endregion

//#region FetchMethods
const getNoBranches = async (): Promise<Branch[]> => {
  return [];
};

const getGlobalAttributes = async (): Promise<Leaf[]> => {
  const fetchResult: Record<string, GlobalAttribute>[] = await globalAttributesApi.get([primaryLanguageCode.value]);

  return fetchResult.map((x) => ({
    id: x[primaryLanguageCode.value].globalAttributeId,
    name: x[primaryLanguageCode.value].name,
    dataType: x[primaryLanguageCode.value].dataType,
    icon: LEAF_ICON
  }));
};
//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MultiLevelNavigationModal, {
    modelValue: localValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
    "modal-title": _ctx.$t('selectGlobalAttribute'),
    "fetch-branches": getNoBranches,
    "fetch-leaves": getGlobalAttributes,
    "selected-entry-id": _ctx.selectedEntryId,
    "selectable-type": ['leaf'],
    "base-path-title": _ctx.$t('global.attributes'),
    "with-all": "",
    onConfirm: onConfirm,
    onHide: _cache[1] || (_cache[1] = ($event: any) => (emits('hide'))),
    onCancel: _cache[2] || (_cache[2] = ($event: any) => (emits('cancel'))),
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('close')))
  }, null, 8, ["modelValue", "modal-title", "selected-entry-id", "base-path-title"]))
}
}

})